module.exports = __webpack_public_path__ + "static/media/summerhill.632e6ee1.png";